
<template>
  <div class="edit_container">
    <div class="editor_wrapper">
      <quill-editor
        v-model="content"
        ref="myQuillEditor"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @change="onEditorChange($event)"
      ></quill-editor>
    </div>
    <button v-on:click="saveHtml" class="center-button">保存</button>
    <div v-if="loading" class="overlay">
      <div class="loading-message">文档较大,请等待...</div>
    </div>
  </div>
</template>







<script>
    import { update_word,GetSubjectWord } from '../../../api/index'
    import {Message} from 'element-ui'
    import { quillEditor } from 'vue-quill-editor'
    import axios from 'axios';
    import * as Quill from 'quill' //引入编辑器
    import { ImageDrop } from 'quill-image-drop-module';
    Quill.register('modules/imageDrop', ImageDrop);

    import  ImageResize  from 'quill-image-resize-module' //调整图片大小
    Quill.register('modules/imageResize', ImageResize)

    import {ImageExtend,QuillWatch } from "quill-image-extend-module"
    Quill.register('modules/ImageExtend', ImageExtend)

    export default {
        components: {
          quillEditor
        },
        name: "SnackManage",
        data() {
            return {
            content: '<h2>开始编辑.....</h2>',
            editorOption: {
                    modules: {
                    ImageExtend:{
                      name:"file",
                      size:5,
                      action:'https://www.windustry.cn/admin/image/upload',
                      response:res => {
                        console.log(res.image)
                        return res.image

                      },
                    },
                    toolbar: {
                      container:[  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ size: ["small", false, "large", "huge"] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ font: [] }], // 字体种类-----[{ font: [] }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  ["clean"], // 清除文本格式-----['clean']
  ["image", "video"] // 链接、图片、视频-----['link', 'image', 'video']
],
                      handlers:{
                        image:function (){
                          QuillWatch.emit(this.quill.id);
                        }
                      }
                    },
                    clipboard: {
                      matchVisual: false
                       },
                    imageResize: { // 调整图片大小配置
                      displayStyles: {
                        backgroundColor: 'black',
                        border: 'none', // 是否加边框
                        color: 'white' // 拖拽时，图片右下角尺寸文字颜色
                      },
                      modules: ['Resize', 'DisplaySize', 'Toolbar'] // 工具包：允许拖拽、显示尺寸、对齐方式
                    },
                  },
            theme: "snow",
            placeholder: "请输入正文",
            },
            imageUrl: '', // 存储图片地址
            tableData:[],
            total:0,
            currentPage:1,
            snackInfo: {},
            dialogFormVisible:false,
            dialogTitle:'',
            labelPosition:'right',
            searchInput:'',
            addcinemaId:'',
            cinemaList:[],
            loading: false // 控制遮罩栏的显示与隐藏
          }
        },
        computed: {
        editor() {
          return this.$refs.myQuillEditor.quill;
        },
      },
        created() {
          const query = window.location.href.split('?')[1]; // 获取 URL 中的查询参数部分（? 后面的部分）
          const urlParams = new URLSearchParams(query);
          this.url_id = urlParams.get('id');
          this.get_word(this.url_id);
        },
      methods: {


          onEditorReady(editor) {// 准备编辑器
          },
          onEditorBlur(){// 失去焦点事件
          },
          onEditorFocus(val,editor){ // 富文本获得焦点时的事件
            console.log(val); // 富文本获得焦点时的内容
            editor.enable(false); // 在获取焦点的时候禁用
          },
          onEditorChange(){// 内容改变事件
          },

        async get_word(id){
            this.loading = true;
            let json = await GetSubjectWord(id)
          if (json.code === 200){
            this.content = json.data
            Message.success(json.msg)
          } else {
            Message.error(json.msg)
          }
          this.loading = false;
        },

          async saveHtml(){
            this.loading = true;
            const query = window.location.href.split('?')[1]; // 获取 URL 中的查询参数部分（? 后面的部分）
          const urlParams = new URLSearchParams(query);
          this.url_id = urlParams.get('id');
          const editorContent = this.content;
          let json = await update_word(this.url_id ,editorContent);
          if (json.code === 200){
            this.$router.push('/home/user_manage');
            Message.success(json.msg)
          } else {
            Message.error(json.msg)
          }
          this.loading = false;
          },


        },
    }
</script>



<style>
.editor_wrapper {
  height: 500px; /* 设置编辑器的高度 */
  overflow-y: auto; /* 添加垂直滚动条 */
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  z-index: 9999; /* 设置遮罩栏的层级 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-message {
  color: white;
  font-size: 18px;
}

/* 设置全屏遮罩 */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.center-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 50px;
  font-size: 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/children/SnackManage.vue